// extracted by mini-css-extract-plugin
module.exports = {"container":"_56c7089d"};